import request from '@/utils/request'
import { BASE_API } from '@/utils/consts'

export function queryCodeToken(id) {
  return request(`${BASE_API}/customer/create_invite_token/${id}`)
}